export enum OfficeEquipmentBrandSortType {
  Id,
  Name,
  IsDeleted
}
